import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { WindowEnums } from 'src/app/enum/window-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { DepartmentModel } from 'src/app/models/management/department.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { DepartmentTableModel } from 'src/app/models/tables/management/department-table.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { DepartmentService } from 'src/app/services/management/department.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterDepartmentComponent } from '../register-department/register-department.component';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss'],
  standalone: false
})
export class DepartmentComponent implements OnInit {
  @ViewChild('departmentModal') departmentModalComponent?: CustomModalComponent | null = null;

  componentRegisterDepartment = RegisterDepartmentComponent;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  data: PagedResponseModel<DepartmentTableModel> = new PagedResponseModel<DepartmentTableModel>();
  header: ColumnResponseModel[] = [];
  inputsForDepartment$ = new BehaviorSubject<any>({
    departmentModel: new DepartmentModel,
  });
  isOpened: string | undefined = undefined;
  limit: number = 10;
  nameWindow: string = 'Departamentos';
  outputForDepartmentModals$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  subscription: Subscription;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: 'delete'
    },
  ];
  url: string = "department";
  userAuthenticated: UserModel = new UserModel();


  constructor(
    private confirmDialogService: ConfirmDialogService,
    private departmentService: DepartmentService,
    private headerService: HeaderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForConsultation(),
      this.getAllDepartmentsWithPagination(),
    ]);
    this.getPermission();
    this.headerService.setTitle(this.nameWindow);
    this.subscription = this.inputsForDepartment$.subscribe(async ({ type }) => {
      switch (type) {
        case 'reload':
          await this.getAllDepartmentsWithPagination();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async deleteDepartment(department: DepartmentTableModel) {

    if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar el departamento ${department.code} - ${department.name}?`)) {
      try {
        await firstValueFrom(this.departmentService.deleteDepartment(department.departmentId));
        this.toastHandlerService.showToast(
          'success',
          'El departamento fue eliminado exitosamente.'
        );
        this.getAllDepartmentsWithPagination();
      } catch (error) {
        console.error('Error al eliminar el departamento.', error);
      }
    }
  }


  async getColumnsForConsultation() {
    try {
      if (this.header.length === 0) {
        this.header = await firstValueFrom(this.departmentService.getColumnsForConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }


  async getAllDepartmentsWithPagination() {
    try {
      this.data = await firstValueFrom(this.departmentService.getAllDepartmentsWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters
      ));
    } catch (error) {
      console.error('Error al buscar los departamentos.', error);
    }
  }


  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por perfil.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Department));
  }

  openModalDepartment() {
    if (!this.validations()) return;

    this.updateInput(new DepartmentModel);
  }

  onAction(event: { action: string, item?: DepartmentTableModel, selectedItems?: number[] }) {
    if (!this.validations()) return;

    if (event.action === 'edit' && event.item) {
      const departmentModel = new DepartmentModel;
      departmentModel.departmentId = event.item.id;
      departmentModel.countryId = event.item.countryId;
      departmentModel.code = event.item.code;
      departmentModel.name = event.item.name;
      this.updateInput(departmentModel)
    }
    if (event.action === 'delete' && event.item) {
      this.deleteDepartment(event.item);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllDepartmentsWithPagination();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadList(reload: boolean) {
    if (reload) {
      this.getAllDepartmentsWithPagination();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );

  }

  updateInput(departmentContract: DepartmentModel) {
    this.inputsForDepartment$.next({
      departmentModel: departmentContract,
    });

    this.departmentModalComponent && this.departmentModalComponent.show();
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar los departamentos. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    return true;
  }
}
